module.exports = __webpack_public_path__ + "media/img/specialize/item7-ccbb540dd1af10db4cfe815231fb83f2.svg";